import React from "react"
import { createUseStyles } from "react-jss"

const useStyles = createUseStyles(theme => {
  return {
    container: {
      width: "100%",
      height: "100%",
      boxShadow:
        "inset 2px 2px 0 rgba(166, 171, 189, 0.3), inset -2px -2px 0 #fafbff",
      borderRadius: "10px",
      backgroundImage: "linear-gradient(166deg, #fafafa 0%, #f0f3f8 100%)",
      padding: "30px",

      [`@media (max-width: ${theme.breakpoints.XS})`]: {
        padding: "20px 15px",
        /* boxShadow: "none",
      borderRadius: "none",
      backgroundImage: "none", */
      },
    },
  }
})

type DataProps = {
  children: React.ReactChild | React.ReactChild[]
}

const Box: React.FC<DataProps> = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.container}>{children}</div>
}

export default Box
